import styled from "styled-components";
import {
  Drawer,
  Classes,
} from "@blueprintjs/core";
import {
  useDarkMode,
} from "ui-components";

import { CompanyT } from "./table";
import CompanyDetailsView from "./details-view";

type Props = {
  isCompanyDetail: boolean;
  setToggleCompanyDetail: () => void;
  currentCompany?: CompanyT;
};
const CompanyDetails = (props: Props) => {
  const { isCompanyDetail, setToggleCompanyDetail, currentCompany } = props;
  const [darkMode] = useDarkMode();
  const companyID = currentCompany?.companyID ? currentCompany.companyID : "";

  return (
    <CustomDrawer
      isOpen={isCompanyDetail}
      onClose={setToggleCompanyDetail}
      className={`mt-xxs p-none ${darkMode ? Classes.DARK : ""}`}
      isCloseButtonShown={true}
      size={"800px"}
    >
      <CompanyDetailsView companyID={companyID} isDrawer={true} setToggleDrawer={setToggleCompanyDetail}/>
    </CustomDrawer>
  );
};

const CustomDrawer = styled(Drawer)`
  background-color: #fff;
  border-radius: 10px;
  padding: 2px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
`;

export default CompanyDetails;
